import { render } from "./cerrarSesion.vue?vue&type=template&id=4b470855"
import script from "./cerrarSesion.vue?vue&type=script&lang=js"
export * from "./cerrarSesion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/administrador/Documents/RepositoriosLMX/app-tent-register/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__